import { useContext } from 'react';
import { FormattedMessage } from 'dibs-react-intl';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Link } from 'dibs-elements/exports/Link';
import ArrowUp from 'dibs-icons/exports/legacy/ArrowUp';

import { CheckoutServerVarsContext } from '../components/shared/CheckoutServerVarsContext';

import styles from './styles/CheckoutSidebarPane.scss';

const requiredLabel = (
    <FormattedMessage
        id="checkout.CheckoutSidebarPaneNew.label.required"
        defaultMessage="Required*"
    />
);

const CheckoutSidebarPane = props => {
    const {
        title,
        children,
        onClick,
        dataTn,
        isClickable,
        isExpanded,
        mobileSummaryPane,
        showRequiredLabel,
    } = props;
    const { isMobile } = useContext(CheckoutServerVarsContext);

    const wrapperClasses = classNames({
        [styles.wrapper]: true,
        [styles.clickable]: isClickable,
        [styles.disabled]: !isClickable && !isExpanded,
        [styles.isMobile]: isMobile && !mobileSummaryPane,
        [styles.mobileSummaryPane]: mobileSummaryPane,
    });

    const arrowStyles = classNames(styles.arrow, {
        [styles.arrowDown]: !isExpanded,
        [styles.disabledArrow]: !isClickable,
        [styles.isMobile]: isMobile,
    });

    const linkProps = { buyerLinkType: 'linkNoDecoration', ariaExpanded: isExpanded, onClick };
    //TODO when were we not using checkout pane title? We can probs use that here instead of getting passed title
    return (
        <div className={wrapperClasses} data-tn={dataTn}>
            <div>
                <Link
                    {...(isClickable ? linkProps : {})}
                    className={classNames(styles.header, {
                        [styles.mobileSummaryHeader]: mobileSummaryPane,
                    })}
                >
                    <h3
                        className={classNames(styles.title, {
                            [styles.isMobile]: isMobile,
                        })}
                    >
                        {title}
                    </h3>
                    {isMobile && showRequiredLabel && isExpanded && (
                        <div className={styles.mobileRequiredLabel}>{requiredLabel}</div>
                    )}
                    <ArrowUp className={arrowStyles} />
                </Link>

                {showRequiredLabel && requiredLabel}

                {isExpanded && children}
            </div>
        </div>
    );
};

CheckoutSidebarPane.propTypes = {
    title: PropTypes.node.isRequired,
    isClickable: PropTypes.bool,
    onClick: PropTypes.func.isRequired,
    children: PropTypes.node,
    dataTn: PropTypes.string.isRequired,
    isExpanded: PropTypes.bool.isRequired,
    mobileSummaryPane: PropTypes.bool,
    showRequiredLabel: PropTypes.bool,
    showBar: PropTypes.bool,
};

export default CheckoutSidebarPane;
